import axios from '@utils/axios';
import router from '@router/router';

const customerDetail = {
  state: {
    customerId: 0,
    street: '',
    streetNumber: '',
    city: '',
    zipCode: '',
    gender: 1,
    email: '',
    name: '',
    surname: '',
    extID: '',
    openLimsID: '',
    agreedToDataProcessing: false,
    agreedToTermsOfService: false,
    phone: { prefix: '', number: '' },
    DNAAgreementDigital: true,
    DNASampleUsageStatus: 0,
    agreedToSampleBeingUsedForScientificPurposes: false,
    agreedToSampleExamination: false,
    registrationSource: 0,
    notifyByEmail: false,
    notifyBySms: false
  },
  mutations: {
    setCustomerId(state, id) {
      state.customerId = id;
    },
    setStreet(state, street) {
      state.street = street;
    },
    setStreetNumber(state, streetNumber) {
      state.streetNumber = streetNumber;
    },
    setCity(state, city) {
      state.city = city;
    },
    setZipCode(state, zipCode) {
      state.zipCode = zipCode;
    },
    setGender(state, gender) {
      state.gender = gender;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setName(state, name) {
      state.name = name;
    },
    setSurname(state, surname) {
      state.surname = surname;
    },
    setExtID(state, id) {
      state.extID = id;
    },
    setOpenLimsID(state, id) {
      state.openLimsID = id;
    },
    setAgreedToDataProcessing(state, val) {
      state.agreedToDataProcessing = val;
    },
    setAgreedToTermsOfService(state, val) {
      state.agreedToTermsOfService = val;
    },
    setPhone(state, phone) {
      state.phone = phone;
    },
    setDNAAgreementDigital(state, digital) {
      state.DNAAgreementDigital = digital;
    },
    setAgreedToSampleBeingUsedForScientificPurposes(state, purposes) {
      state.agreedToSampleBeingUsedForScientificPurposes = purposes;
    },
    setAgreedToSampleExamination(state, exam) {
      state.agreedToSampleExamination = exam;
    },
    setDNASampleUsageStatus(state, status) {
      state.DNASampleUsageStatus = status;
    },
    setRegistrationSource(state, source) {
      state.registrationSource = source;
    },
    setNotifyByEmail(state, val) {
      state.notifyByEmail = val;
    },
    setNotifyBySms(state, val) {
      state.notifyBySms = val;
    }
  },
  actions: {
    fetchCustomer(context) {
      return axios.get('admin/customers/customer', {
        params: {
          CustomerId: context.state.customerId
        }
      })
        .then((res) => {
          if (res.status === 404) {
            router.push({ name: 'admin.customers.view' });
          } else if (res.status === 200) {
            context.commit('setStreet', res.data.result.address.street);
            context.commit('setStreetNumber', res.data.result.address.streetNumber);
            context.commit('setCity', res.data.result.address.city);
            context.commit('setZipCode', res.data.result.address.zipCode);
            context.commit('setGender', res.data.result.gender.value);
            context.commit('setEmail', res.data.result.email);
            context.commit('setName', res.data.result.name);
            context.commit('setSurname', res.data.result.surname);
            context.commit('setExtID', res.data.result.extID);
            context.commit('setOpenLimsID', res.data.result.openLimsID);
            context.commit('setAgreedToDataProcessing', res.data.result.agreedToDataProcessing);
            context.commit('setAgreedToTermsOfService', res.data.result.agreedToTermsOfService);
            context.commit('setDNAAgreementDigital', res.data.result.dnaAgreementWasDigital);
            context.commit('setDNASampleUsageStatus', res.data.result.dnaSampleUsageStatus || 0);
            context.commit('setAgreedToSampleBeingUsedForScientificPurposes', res.data.result.agreedToSampleBeingUsedForScientificPurposes);
            context.commit('setAgreedToSampleExamination', res.data.result.agreedToSampleExamination);
            context.commit('setPhone', res.data.result.phone);
            context.commit('setRegistrationSource', res.data.result.registrationSource);
            context.commit('setNotifyByEmail', res.data.result.notifyByEmail);
            context.commit('setNotifyBySms', res.data.result.notifyBySms);
            Promise.resolve(true);
          }
        }).catch(() => {
          router.push({ name: 'admin.dashboard' });
        });
    },
    resetContext(context) {
      context.commit('setCustomerId', 0);
      context.commit('setStreet', '');
      context.commit('setStreetNumber', '');
      context.commit('setCity', '');
      context.commit('setZipCode', '');
      context.commit('setGender', 1);
      context.commit('setEmail', '');
      context.commit('setName', '');
      context.commit('setSurname', '');
      context.commit('setExtID', '');
      context.commit('setOpenLimsID', '');
      context.commit('setAgreedToDataProcessing', false);
      context.commit('setAgreedToTermsOfService', false);
      context.commit('setDNAAgreementDigital', true);
      context.commit('setDNASampleUsageStatus', 0);
      context.commit('setAgreedToSampleBeingUsedForScientificPurposes', false);
      context.commit('setAgreedToSampleExamination', false);
      context.commit('setPhone', { prefix: '', number: '' });
      context.commit('setRegistrationSource', 0);
      context.commit('setNotifyByEmail', false);
      context.commit('setNotifyBySms', false);
    },
    editCustomer(context) {
      return axios.post('admin/customers', {
        CustomerId: Number(context.state.customerId),
        Name: context.state.name,
        Surname: context.state.surname,
        PhonePrefix: context.state.phone.prefix,
        Phone: context.state.phone.number,
        Email: context.state.email,
        Gender: context.state.gender,
        Street: context.state.street,
        StreetNumber: context.state.streetNumber,
        City: context.state.city,
        Zipcode: context.state.zipCode,
        OpenLimsID: context.state.openLimsID,
        DNASampleUsageStatus: context.state.DNASampleUsageStatus,
        AgreedToSampleBeingUsedForScientificPurposes: context.state.agreedToSampleBeingUsedForScientificPurposes,
        AgreedToSampleExamination: context.state.agreedToSampleExamination,
        NotifyByEmail: context.state.notifyByEmail,
        NotifyBySms: context.state.notifyBySms,
      });
    }
  },
  namespaced: true
};

export default customerDetail;
